import React from "react";
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend
} from "recharts";
import './VwapLineChart.css';

const VWAPLineChart = ({ chartData, stockInfo, selectedPeriod }) => {
  if (!chartData || chartData.length === 0) return <p>No data to display.</p>;

  const xTicks =
    ['3Y', '5Y', 'MAX'].includes(selectedPeriod)
      ? Array.from(
          new Set(chartData.map(d => new Date(d.date).getFullYear()))
        )
          .map(year => {
            const first = chartData.find(d => new Date(d.date).getFullYear() === year);
            return first?.date;
          })
          .filter(Boolean)
      : undefined;

  return (
    <div className="chart-content">
      <h3>Volume Weighted Average Price Trend - {stockInfo.name} ({stockInfo.ticker})</h3>
      <div className="chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <RechartsLineChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 10, bottom: 30 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12 }}
              interval="preserveStartEnd"
              tickFormatter={(value) => {
                const date = new Date(value);
                return ['3Y', '5Y', 'MAX'].includes(selectedPeriod)
                  ? date.getFullYear().toString()
                  : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
              }}
              ticks={xTicks}
            />
            <YAxis
              domain={['auto', 'auto']}
              tick={{ fontSize: 12 }}
              width={60}
              tickFormatter={(value) => `$${value.toFixed(0)}`}
            />
            <Tooltip
              formatter={(value) => [`$${value.toFixed(2)}`, "VWAP"]}
              labelFormatter={(label) => `Date: ${label}`}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="vwap"
              name="VWAP"
              stroke="#8884d8"
              strokeWidth={2}
              dot={{ r: 1 }}
              activeDot={{ r: 5 }}
            />
          </RechartsLineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default VWAPLineChart;

